import React, { memo } from 'react'
import LogoLoop from './LogoLoop'

import centric       from '../images/clients/Centric_Events_Rentals.jpg'
import mia           from '../images/clients/MIA_group_of_compnies.jpg'
import cakesBakes    from '../images/clients/Cakes_Bakes.jpg'
import aliRaza       from '../images/clients/Ali_zaid_Brothers.jpg'
import alHamd        from '../images/clients/Alhamd_corporation.jpg'
import avertia       from '../images/clients/averti_infotech.jpg'
import axr           from '../images/clients/AXR_solution.jpg'
import borjan        from '../images/clients/Borjan.jpg'
import ecozoham      from '../images/clients/Ecozohm.jpg'
import soi           from '../images/clients/OIL_Northern.jpg'
import evolved       from '../images/clients/evolved_office.jpg'
import bigJerry      from '../images/clients/BIG_jerry_fencing.jpg'
import oman          from '../images/clients/Muscat_Media_Group.jpg'
import hush          from '../images/clients/Hush_Puppies.jpg'
import ziePie        from '../images/clients/Zie_Pie.jpg'
import orr           from '../images/clients/orr_protection.jpg'
import timesOfOman   from '../images/clients/Oman_data_park.jpg'
import net           from '../images/clients/Net_Atlantic.jpg'
import orangeline    from '../images/clients/Orange_Line.jpg'
import renewell      from '../images/clients/rene_well_water.jpg'
import muscatMedia   from '../images/clients/Muscat_Media_Group.jpg'
import nurtureful    from '../images/clients/Nutureful.jpg'

const logos = [
  { src: centric,     alt: 'Centric_Events_Rentals' },
  { src: mia,         alt: 'MIA_group_of_compnies' },
  { src: cakesBakes,  alt: 'Cakes & Bakes' },
  { src: aliRaza,     alt: 'Ali zaid Brothers' },
  { src: alHamd,      alt: 'Alhamd corporation' },
  { src: avertia,     alt: 'averti infotech' },
  { src: axr,         alt: 'AXR solution' },
  { src: borjan,      alt: 'Borjan' },
  { src: ecozoham,    alt: 'Ecozohm' },
  { src: soi,         alt: 'SOI Northern' },
  { src: evolved,     alt: 'Evolved Office' },
  { src: bigJerry,    alt: "Big Jerry's Fencing" },
  { src: oman,        alt: 'Muscat Media Group' },
  { src: hush,        alt: 'Hush Puppies' },
  { src: ziePie,      alt: 'Zie Pie' },
  { src: orr,         alt: 'ORR Protection' },
  { src: timesOfOman, alt: 'Oman Data Park' },
  { src: net,         alt: 'Net Atlantic' },
  { src: orangeline,  alt: 'Orange Line' },
  { src: renewell,    alt: 'Renewell Water' },
  { src: muscatMedia, alt: 'Muscat Media Group' },
  { src: nurtureful,  alt: 'Nurtureful' },
]

const HappyClients = () => {
  return (
    <section className="tc-section">
      <h2 className="tc-heading">
        Trusted by more than
        <span className="tc-heading__accent">25 organizations</span>
      </h2>
      <p className="tc-sub">
        Enterprises across the Middle East, Europe, and North America rely on Visiomate
        to build, optimize, and scale their technology.
      </p>
      <div style={{ height: '140px', position: 'relative', overflow: 'hidden' }}>
        <LogoLoop
          logos={logos}
          speed={100}
          direction="left"
          logoHeight={80}
          gap={0}
          hoverSpeed={0}
          scaleOnHover
          fadeOut
          fadeOutColor="#ffffff"
          ariaLabel="Happy clients"
          style={{ '--logoloop-logoWidth': '220px' }}
        />
      </div>
    </section>
  )
}

export default memo(HappyClients)
